module.exports = __webpack_public_path__ + "static/image 115-69ffb1e5465958afe22009c4e2d846a4.jpg";